<template>
    <div>
        <app-sub-title text="Usuarios" />
        <button
            class="btn btn-primary"
            @click="startSaveUser()"
            v-if="userCan('create-user')"
        >
            <i class="fa fa-user-plus"></i> Crear nuevo usuario
        </button>
        <div class="filters">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="d-flex justify-content-around">
                            <b-row>
                                <b-col cols="12" md="2">
                                    <app-form-text-input
                                        placeholder="Nombre"
                                        v-model="filters.name"
                                    />
                                </b-col>
                                <b-col cols="12" md="2">
                                    <app-form-text-input
                                        placeholder="Nombre usuario"
                                        v-model="filters.username"
                                    />
                                </b-col>
                                <b-col cols="12" md="2">
                                    <app-form-text-input
                                        placeholder="Documento"
                                        v-model="filters.document"
                                    />
                                </b-col>
                                <b-col cols="12" md="2">
                                    <app-form-select-input
                                        placeholder="Perfil"
                                        :options="profiles"
                                        v-model="filters.profile"
                                    />
                                </b-col>
                                <b-col cols="12" md="4">
                                    <app-autocomplete
                                        placeholder="Cliente"
                                        :items="clients"
                                        v-model="selectClient"
                                    />
                                </b-col>
                                <b-col cols="12" md="2">
                                    <b-checkbox
                                        v-model="filters.inactives"
                                        :value="1"
                                        :unchecked-value="0"
                                    >
                                        Solo inactivos
                                    </b-checkbox>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <div class="pull-right">
                                        <button
                                            @click="searchUsers"
                                            class="btn btn-primary flex-grow-0 flex-shrink-0"
                                        >
                                            <i class="fa fa-filter"></i>
                                        </button>
                                        <button
                                            @click="cancelFilter"
                                            class="btn btn-secondary flex-grow-0 flex-shrink-0"
                                        >
                                            <i class="fa fa-times-circle"></i>
                                        </button>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-table-users
            :data="data"
            @change-page="onChangePage"
            @reset-password="startReset"
            @update-user="startUpdate"
            @remove-user="startRemove"
            @sort="sort"
            @see-assignations="seeAssignations"
            @activate="activate"
            @watch-log="onWatchLog"
            @photo-updated="onPhotoUpdated"
            @update-photo="onUpdatePhoto"
            @delete-photo="onDeletePhoto"
        />
        <!-- inicio de pop up's -->
        <app-pop-up title="Confirmación" id="user-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este usuario?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="deleteUser(selectedUser)"
                >
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="user-reset-password">
            <div slot="body">
                <h2>¿Esta seguro que desea restaurar la contraseña?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="restorePassword(selectedUser)"
                >
                    <i class="fa fa-retweet" aria-hidden="true"></i> Confirmar
                    restauración de contraseña
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario de usuario"
            id="user-form"
            size="large"
            :onClose="cleanForm"
        >
            <div class="body" slot="body">
                <app-users-page-form
                    :my-user="selectedUser"
                    :onSave="onSave"
                ></app-users-page-form>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('user-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Clientes asignados" id="see-assignations">
            <div slot="body">
                Clientes asignados usuario <b> {{ selectedUser.name }} </b>
                <b-list-group>
                    <b-list-group-item
                        v-for="assignation in selectedUser.assignations"
                        :key="assignation.id"
                    >
                        {{ assignation.structure.name }} ({{
                            !!assignation.structure.client
                                ? assignation.structure.client.name
                                : 'No Cliente'
                        }})
                    </b-list-group-item>
                </b-list-group>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Log del usuario"
            id="user-log-window"
            :on-close="onWatchLogClose"
        >
            <template slot="body">
                <app-data-table
                    :fields="userLogFields"
                    :items="userLogs"
                ></app-data-table>
            </template>
        </app-pop-up>

        <app-pop-up
            :title="`Actualizar foto de ${selectedUser.name}`"
            id="update-photo-window"
            :on-close="onUpdatePhotoWindowClose"
            :on-show-up="onUpdatePhotoWindowShowUp"
        >
            <template slot="body">
                <app-update-photo
                    v-if="!!selectedUser"
                    :selected-user="selectedUser"
                    ref="update-photo-form"
                    @photo-updated="onPhotoUpdated"
                ></app-update-photo>
            </template>
            <template slot="buttons">
                <b-btn
                    variant="primary"
                    @click="onSavePhoto"
                    :disabled="inProgress"
                >
                    Actualizar Foto
                </b-btn>
            </template>
        </app-pop-up>

        <!-- fin de pop up's -->
    </div>
</template>
<script>
import userRepository from '../../../repositories/users.repository.js'
import UsersPage from '../UsersPage/UsersPage.vue'
import TableUsers from './TableUsers/TableUsers.vue'
import { mapGetters } from 'vuex'
import usersRepository from '../../../repositories/users.repository.js'
import WebCamLite from '@components/UI/Controls/WebCamLite/WebCamLite'
import UpdatePhoto from './UpdatePhoto/UpdatePhoto'

export default {
    components: {
        appUsersPageForm: UsersPage,
        appTableUsers: TableUsers,
        appWebCamLite: WebCamLite,
        appUpdatePhoto: UpdatePhoto,
    },

    data() {
        return {
            page: 1,
            selectedUser: '',
            data: {},
            filters: {
                profile: '',
                client: '',
                name: '',
                document: '',
                username: '',
                sortBy: 'name',
                sortDir: 'asc',
                inactives: 0,
            },
            selectClient: '',
            userLogs: [],
            userLogFields,
            selectedUserPhoto: '',
        }
    },

    watch: {
        selectClient(val) {
            if (!val) {
                this.filters.client = ''
                this.selectClient = ''
            } else {
                this.filters.client = val.id
            }
        },
    },

    computed: {
        ...mapGetters(['clients', 'profiles']),
    },

    methods: {
        sort(sortConf) {
            this.filters.sortBy = sortConf.sortBy
            this.filters.sortDir = sortConf.sortDir
            this.loadUsers()
        },
        onSave() {
            this.$bus.$emit('user-form.close')
            this.loadUsers()
        },
        cleanForm() {
            this.$bus.$emit('user-form.clean')
        },
        loadUsers() {
            const ur = Object.assign({}, userRepository)
            ur.all({ ...this.filters, trashed: 1 }, this.page)
                .then(data => {
                    this.data = data
                })
                .catch(error =>
                    toastr.error('Ocurrio un error al cargar los usuarios')
                )
        },
        onChangePage(page) {
            this.page = page
            this.loadUsers()
        },
        deleteUser(user) {
            const ur = Object.assign({}, userRepository)
            ur.deleteUser(user.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadUsers()
                        this.$bus.$emit('user-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el usuario')
                })
        },
        restorePassword(user) {
            const ur = Object.assign({}, userRepository)
            ur.resetPassword(user.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.$bus.$emit('user-reset-password.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo restaurar la contraseña')
                })
        },
        startRemove(user) {
            this.selectedUser = user
            this.$bus.$emit('user-remove.open')
        },
        startReset(user) {
            this.selectedUser = user
            this.$bus.$emit('user-reset-password.open')
        },
        startUpdate(user) {
            this.selectedUser = Object.assign({}, user)
            this.$bus.$emit('user-form.open')
        },
        startSaveUser() {
            this.selectedUser = ''
            this.$bus.$emit('user-form.open')
        },
        searchUsers() {
            this.page = 1
            this.loadUsers()
        },
        cancelFilter() {
            this.page = 1
            this.selectClient = ''
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.loadUsers()
        },
        seeAssignations(user) {
            this.selectedUser = Object.assign({}, user)
            this.$bus.$emit('see-assignations.open')
        },
        async activate(userId) {
            const ur = { ...usersRepository }

            try {
                const { data } = await ur.activate(userId)
                if (data.status) {
                    const index = this.data.data.findIndex(
                        item => item.id === userId
                    )
                    if (-1 !== index) {
                        const user = {
                            ...this.data.data[index],
                            deleted_at: '',
                        }
                        this.data.data.splice(index, 1, user)
                    }
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                toastr.error(`Error al activar usuario [${err.message}]`)
            }
        },
        async onWatchLog(userId) {
            this.$bus.$emit('user-log-window.open')

            const ur = { ...userRepository }

            const { data } = await ur.getLogs(userId)

            this.userLogs = data
        },
        onWatchLogClose() {
            this.userLogs = []
        },
        onUpdatePhoto(user) {
            this.selectedUser = user
            this.$bus.$emit('update-photo-window.open')
        },
        onSavePhoto() {
            this.$refs['update-photo-form'].savePhoto()
        },
        onPhotoUpdated(data) {
            this.$bus.$emit('update-photo-window.close')
            const index = this.data.data.findIndex(
                item => item.id === this.selectedUser.id
            )
            const user = { ...this.data.data[index], photo: data.photoUrl }
            this.data.data.splice(index, 1, user)
            this.selectedUser = ''
        },
        onUpdatePhotoWindowClose() {
            this.$bus.$emit('camera.off')
        },
        onUpdatePhotoWindowShowUp() {
            this.$bus.$emit('camera.on')
        },
        async onDeletePhoto(user) {
            this.selectedUser = user
            const ur = { ...usersRepository }

            try {
                const { data } = await ur.deletePhoto(user.id)
                if (data.status) {
                    const index = this.data.data.findIndex(
                        item => item.id === this.selectedUser.id
                    )
                    const user = { ...this.data.data[index], photo: null }
                    this.data.data.splice(index, 1, user)
                    toastr.success('Foto eliminada')
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                this.handleErrors(err)
            } finally {
                this.selectedUser = ''
            }
        },
    },

    created() {
        this.loadUsers()
        this.load('profiles')
    },
}

const userLogFields = [
    {
        key: 'author.name',
        label: 'Autor',
    },
    {
        key: 'author.document',
        label: 'Documento',
    },
    {
        key: 'activity',
        label: 'Actividad',
    },
    {
        key: 'created_at',
        label: 'Fecha',
    },
]
</script>
